import { createPostEndpoint } from '@sonar-software/sonar-http';
import { UserInvitation } from '../@types/UserInvitation';
import { UserInvitationError } from '../@types/UserInvitationError';

export type PostInviteUsersRequest = {
	users: UserInvitation[];
};

export type PostInviteUsersResponse = {
	invalidUsers: UserInvitationError[];
};

export const postInviteUsers = createPostEndpoint<PostInviteUsersRequest, PostInviteUsersResponse>(
	'/api/v3/security/authentication/invite'
);
